import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import MainRadio from '../../MUI/MainRadio';

const ChangeApplicant = (props) => {
  const {
    onChange,
    hasApplicantOption,
    value,
    primaryOption,
    hasPrimaryOption,
    applicantIsAdult,
  } = props;

  const {
    primaryLabel = 'claim.personalData.insuredPerson',
    primaryValue = 'insuredPerson',
  } = primaryOption;

  const [isOtherApplicant, setIsOtherApplicant] = useState(false);

  useEffect(() => {
    setIsOtherApplicant(value === 'other' || value === 'otherLegal');
  }, [value]);

  return (
    <Grid container spacing={2} style={{ marginBottom: 16 }}>
      {hasPrimaryOption && (
        <Grid item xs={12}>
          <MainRadio
            checked={value === primaryValue}
            value={primaryValue}
            onChange={({ e }) => {
              setIsOtherApplicant(false);
              onChange(e.target.value);
            }}
            labelKey={primaryLabel}
            disabled={!applicantIsAdult}
          />
        </Grid>
      )}
      {hasApplicantOption && (
        <Grid item xs={12}>
          <MainRadio
            checked={value === 'applicant'}
            value="applicant"
            onChange={({ e }) => {
              setIsOtherApplicant(false);
              onChange(e.target.value);
            }}
            labelKey="claim.compensation.paymentReceiverType.applicant"
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <MainRadio
          checked={isOtherApplicant}
          onChange={({ data }) => {
            setIsOtherApplicant(data);
            onChange('other');
          }}
          labelKey="personalClaim.personalData.other"
          value={isOtherApplicant}
        />
      </Grid>

      {isOtherApplicant && (
        <Grid container item spacing={2}>
          <Grid item>
            <MainRadio
              checked={value === 'other'}
              onChange={({ e }) => {
                onChange(e.target.value);
              }}
              labelKey="personalClaim.personalData.otherPhysical"
              value="other"
            />
          </Grid>
          <Grid item>
            <MainRadio
              checked={value === 'otherLegal'}
              onChange={({ e }) => {
                onChange(e.target.value);
              }}
              labelKey="personalClaim.personalData.otherLegal"
              value="otherLegal"
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

ChangeApplicant.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  hasApplicantOption: PropTypes.bool,
  primaryOption: PropTypes.shape({
    primaryLabel: PropTypes.string,
    primaryValue: PropTypes.string,
  }),
  hasPrimaryOption: PropTypes.bool,
  applicantIsAdult: PropTypes.bool,
};

ChangeApplicant.defaultProps = {
  value: '',
  onChange: () => {},
  hasApplicantOption: false,
  primaryOption: {},
  hasPrimaryOption: true,
  applicantIsAdult: true,
};

export default ChangeApplicant;
